var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-0"},[_c('div',{staticClass:"row mb-2 mb-xl-3"},[_c('div',{staticClass:"col-auto d-none d-sm-block"},[_c('h3',[_c('strong',[_vm._v("Delivery")]),_vm._v(" schedules")])])])])
}]

export { render, staticRenderFns }